module.exports = __webpack_public_path__ + "static/media/mardelaspampas.1693a789.webp";